import {
 Redirect, Route, Switch, useLanguage, withRouter,
} from '@ipc/ipc-core';
import { Notifications } from '@ipc/ipc-components';
import React from 'react';
import { useSelector } from 'react-redux';
import ApplicationAccessMenuContainer from '../common/asset-types/ApplicationAccessMenuContainer';
import PrivateRoute from '../common/PrivateRoute';
import ListTableContainer from '../common/tables/containers/ListTableContainer';
import WeeklyThresholdsEditContainer from './yearly-thresholds/bulk-edit/container/WeeklyThresholdsEditContainer';
import ImpcEditContainer from './impc-edit/containers/ImpcEditContainer';
import ViewTransactionsPageContainer from './transaction-management/view-transaction/containers/ViewTransactionsPageContainer';
import ViewTransactionHistoryContainer from './transaction-management/view-transaction-history/containers/ViewTransactionHistoryContainer';
import EditRouteContainer from './route-management/edit/containers/EditRouteContainer';
import RouteManagementCreateContainer from './route-management/create/containers/RouteManagementCreateContainer';
import EdiRfidAuditRequestCreateContainer from './edi-rfid-audit/request/create/EdiRfidAuditRequestCreateContainer';
import DailyRouteLeadingCountStatusListContainer
  from './daily-route-leading-count-status/containers/DailyRouteLeadingCountStatusListContainer';
import DailyRouteLeadingCountContainer from './reporting/daily-route-leading-count/containers/DailyRouteLeadingCountContainer';
import EdiRfidAuditRequestExecutionReportContainer from './edi-rfid-audit/execution/report/containers/EdiRfidAuditRequestExecutionReportContainer';
import BalanceOnHandThresholdsEditContainer from './impc-stock-levels/impc-characteristics/boh-thresholds/edit/containers/BalanceOnHandThresholdsEditContainer';
import { getNotification } from '../common/redux/selectors/notificationSelector';
import PoolMembershipManagementContainer
  from './pool-membership-management/containers/PoolMembershipManagementContainer';
import { NotificationsAdapter } from '../common/notifications/NotificationsAdapter';
import Login from '../common/Login';
import Dashboard from '../common/Dashboard';
import NotFound from '../common/NotFound';

export const AppContent = () => {
  const [, language] = useLanguage();
  const notification = useSelector(getNotification);

  return (
    <>
      <div>
        <NotificationsAdapter notification={notification} />
        <Notifications />
      </div>
      <Switch>
        <Route exact path={language('/login')}>
          <Route component={Login} />
        </Route>
        <PrivateRoute exact path={language('/')} render={() => <Redirect to={`/${language('application-type')}`} />} />
        <Switch>
          <PrivateRoute exact path={language('/application-type')} component={ApplicationAccessMenuContainer} />
          <PrivateRoute exact path={language('/user-list')} render={(props) => <ListTableContainer {...props} tableId="USER_LIST_PAGE" />} />
          <PrivateRoute exact path={language('/impc-details')} render={(props) => <ListTableContainer {...props} tableId="IMPC_DETAILS_PAGE" />} />
          <PrivateRoute exact path={language('/impc-edit')} render={(props) => <ImpcEditContainer {...props} />} />
          <PrivateRoute exact path={language('/yearly-thresholds')} render={(props) => <ListTableContainer {...props} tableId="YEARLY_THRESHOLDS_PAGE" />} />
          <PrivateRoute exact path={language('/weekly-thresholds-edit')} render={(props) => <WeeklyThresholdsEditContainer {...props} />} />
          <PrivateRoute exact path={language('/balance-on-hand-thresholds-edit')} render={(props) => <BalanceOnHandThresholdsEditContainer {...props} />} />
          <PrivateRoute exact path={language('/route-management')} render={(props) => <ListTableContainer {...props} tableId="ROUTE_MANAGEMENT_PAGE" />} />
          <PrivateRoute exact path={language('/impc-stock-levels')} render={(props) => <ListTableContainer {...props} tableId="IMPC_STOCK_LEVELS_ALL_LIST" />} />
          <PrivateRoute exact path={language('/reporting/balance-on-hand')} render={(props) => <ListTableContainer {...props} tableId="REPORTING_BALANCE_ON_HAND_PAGE" />} />
          <PrivateRoute exact path={language('/member-pool-storage')} render={(props) => <ListTableContainer {...props} tableId="MEMBER_POOL_STORAGE_PAGE" />} />
          <PrivateRoute exact path={language('/reporting/flux-volume-oe')} render={(props) => <ListTableContainer {...props} tableId="REPORTING_FLUX_VOLUME_OE" />} />
          <PrivateRoute exact path={language('/reporting/flux-volume-operator')} render={(props) => <ListTableContainer {...props} tableId="REPORTING_FLUX_VOLUME_OPERATOR" />} />
          <PrivateRoute exact path={language('/internal-repatriations')} render={(props) => <ListTableContainer {...props} tableId="REPORTING_INTERNAL_REPATRIATIONS" />} />
          <PrivateRoute exact path={language('/center-initiated-repatriations')} render={(props) => <ListTableContainer {...props} tableId="REPORTING_CENTER_INITIATED_REPATRIATIONS" />} />
          <PrivateRoute exact path={language('/reporting/total-pool-breakdown')} render={(props) => <ListTableContainer {...props} tableId="REPORTING_TOTAL_POOL_BREAKDOWN" />} />
          <PrivateRoute exact path={language('/reporting/rfid-movement-count')} render={(props) => <ListTableContainer {...props} tableId="REPORTING_RFID_MOVEMENT_COUNT" />} />
          <PrivateRoute exact path={language('/reporting/rfids-on-route')} render={(props) => <ListTableContainer {...props} tableId="REPORTING_RFID_ON_ROUTE" />} />
          <PrivateRoute exact path={language('/transaction-management')} render={(props) => <ViewTransactionsPageContainer {...props} tableId="TRANSACTION_MANAGEMENT" />} />
          <PrivateRoute exact path={language('/transaction-history')} render={(props) => <ViewTransactionHistoryContainer {...props} tableId="TRANSACTION_HISTORY" />} />
          <PrivateRoute exact path={language('/edit-route')} render={(props) => <EditRouteContainer {...props} />} />
          <PrivateRoute exact path={language('/create-route')} render={(props) => <RouteManagementCreateContainer {...props} />} />
          <PrivateRoute exact path={language('/edi-rfid-audit')} render={(props) => <ListTableContainer {...props} tableId="EDI_RFID_AUDIT_REQUESTS_LIST_PAGE" />} />
          <PrivateRoute exact path={language('/edi-rfid-audit/create')} render={(props) => <EdiRfidAuditRequestCreateContainer {...props} />} />
          <PrivateRoute exact path={language('/rfid-management')} render={(props) => <ListTableContainer {...props} tableId="RFID_UPLOADED_FILES_LIST" />} />
          <PrivateRoute exact path={language('/pool-management')} render={(props) => <PoolMembershipManagementContainer {...props} />} />
          <PrivateRoute
            exact
            path={language('/daily-route-leading-count-status')}
            render={(props) => <DailyRouteLeadingCountStatusListContainer {...props} tableId="DAILY_ROUTE_LEADING_COUNT_STATUS_PAGE" />}
          />
          <PrivateRoute
            exact
            path={language('/reporting/daily-route-leading-count')}
            render={(props) => <DailyRouteLeadingCountContainer {...props} tableId="DAILY_ROUTE_LEADING_COUNT_SUMMARY" />}
          />
          <PrivateRoute
            exact
            path={language('/edi-rfid-audit-request-report')}
            render={(props) => <EdiRfidAuditRequestExecutionReportContainer {...props} tableId="EDI_RFID_AUDIT_REQUEST_EXECUTION_REPORT" />}
          />
          <PrivateRoute exact path={language('/recalculate-tasks')} render={(props) => <ListTableContainer {...props} tableId="RECALCULATE_TASKS_LIST" />} />
          <PrivateRoute
            exact
            path={language('/dashboard')}
            component={Dashboard}
          />
          <Route component={NotFound} />
        </Switch>
      </Switch>
    </>
  );
};

export default withRouter(AppContent);
